export default {
    //Modal
    on_cancel_title: 'Abbrechen',
    on_process_title: 'Bestätigen Sie'
}